const React = require("react");
const T = require("prop-types");
const NavLink = require("react-router-dom").NavLink;
const Classes = require("./styles.scss");
const IconMenu = require("material-ui/IconMenu").default;
const IconButton = require("material-ui/IconButton").default;
const MenuItem = require("material-ui/MenuItem").default;
const UserIcon = require("material-ui/svg-icons/social/person").default;
const FlatButton = require("material-ui/FlatButton").default;
const Badge = require("material-ui/Badge").default;
const Divider = require("material-ui/Divider").default;
const MenuIcon = require("material-ui/svg-icons/navigation/menu").default;
const { withRouter } = require("react-router-dom");

const internals = {};

internals.menuItemStyle = {
    fontSize: "14px"
};

internals.buttonLabelStyle = {
    textTransform: "inherit"
};

class Header extends React.Component {
    static propTypes = {
        numCredits: T.number,
        logout: T.func.isRequired,
        isAuthenticated: T.bool.isRequired,
        isAdmin: T.bool.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.renderNav = this._renderNav.bind(this);
        this.renderAuthenticatedNav = this._renderAuthenticatedNav.bind(this);
        this.renderAdminNav = this._renderAdminNav.bind(this);
    }

    _renderNav() {
        return (
            <div className={Classes.navGroup}>
                <div className={Classes.navMobile}>
                    <IconMenu
                        iconButtonElement={
                            <IconButton>
                                <MenuIcon />
                            </IconButton>
                        }
                    >
                        {/* <MenuItem
                            primaryText='Buy Credits'
                            containerElement={<NavLink to='/buycredits' />}
                            style={internals.menuItemStyle}
            /> */}
                        <MenuItem
                            primaryText="Login"
                            containerElement={<NavLink to="/login" />}
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="Blog"
                            containerElement={
                                <a
                                    href="http://mybodymodel.com/blog"
                                    target="_blank"
                                />
                            }
                            style={internals.menuItemStyle}
                        />
                    </IconMenu>
                </div>
                <div className={Classes.navDesktop}>
                    {/* <FlatButton
                        label='Buy Credits'
                        containerElement={<NavLink to='/buycredits' />}
                        labelStyle={internals.buttonLabelStyle}
          /> */}
                    <FlatButton
                        label="Login"
                        containerElement={<NavLink to="/login" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="Blog"
                        containerElement={
                            <a
                                href="http://mybodymodel.com/blog"
                                target="_blank"
                            />
                        }
                        labelStyle={internals.buttonLabelStyle}
                    />
                </div>
            </div>
        );
    }

    _renderAuthenticatedNav(numCredits) {
        return (
            <div className={Classes.navGroup}>
                <div className={Classes.navMobile}>
                    <IconMenu
                        iconButtonElement={
                            <IconButton>
                                <MenuIcon />
                            </IconButton>
                        }
                    >
                        <MenuItem
                            primaryText="Buy Credits"
                            containerElement={<NavLink to="/buycredits" />}
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="New Preview"
                            containerElement={<NavLink to="/instructions" />}
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="My Portfolio"
                            containerElement={<NavLink to="/portfolio" />}
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="Blog"
                            containerElement={
                                <a
                                    href="http://mybodymodel.com/blog"
                                    target="_blank"
                                />
                            }
                            style={internals.menuItemStyle}
                        />
                        <Divider />
                        <MenuItem
                            primaryText={`(${numCredits}) Credit(s) Remaining`}
                            style={internals.menuItemStyle}
                            disabled
                            className={Classes.menuItemInfo}
                        />
                        <Divider />
                        <MenuItem
                            primaryText="Update Email"
                            containerElement={<NavLink to="/update-email" />}
                            style={internals.menuItemStyle}
                        />

                        {this.props.isAdmin && (
                            <MenuItem
                                primaryText="Admin"
                                containerElement={<NavLink to="/admin" />}
                                style={internals.menuItemStyle}
                            />
                        )}
                        <MenuItem
                            primaryText="Logout"
                            style={internals.menuItemStyle}
                            onClick={this.props.logout}
                        />
                    </IconMenu>
                </div>
                <div className={Classes.navDesktop}>
                    <FlatButton
                        label="Buy Credits"
                        containerElement={<NavLink to="/buycredits" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="New Preview"
                        containerElement={<NavLink to="/instructions" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="My Portfolio"
                        containerElement={<NavLink to="/portfolio" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="Blog"
                        containerElement={
                            <a
                                href="http://mybodymodel.com/blog"
                                target="_blank"
                            />
                        }
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <IconMenu
                        iconButtonElement={
                            <IconButton>
                                <UserIcon />
                                <Badge
                                    badgeContent={numCredits}
                                    primary
                                    style={{
                                        padding: "0",
                                        position: "relative"
                                    }}
                                    badgeStyle={{
                                        fontSize: "9px",
                                        height: "18px",
                                        width: "18px",
                                        top: -34
                                    }}
                                />
                            </IconButton>
                        }
                    >
                        <MenuItem
                            primaryText={`(${numCredits}) Credit(s) Remaining`}
                            style={internals.menuItemStyle}
                            disabled
                            className={Classes.menuItemInfo}
                        />
                        <Divider />
                        <MenuItem
                            primaryText="Update Email"
                            containerElement={<NavLink to="/update-email" />}
                            style={internals.menuItemStyle}
                        />
                        <Divider />
                        {this.props.isAdmin && (
                            <MenuItem
                                primaryText="Admin"
                                containerElement={<NavLink to="/admin" />}
                                style={internals.menuItemStyle}
                            />
                        )}
                        <MenuItem
                            primaryText="Logout"
                            style={internals.menuItemStyle}
                            onClick={this.props.logout}
                        />
                    </IconMenu>
                </div>
            </div>
        );
    }

    _renderAdminNav() {
        return (
            <div className={Classes.navGroup}>
                <div className={Classes.navMobile}>
                    <IconMenu
                        iconButtonElement={
                            <IconButton>
                                <MenuIcon />
                            </IconButton>
                        }
                    >
                        <MenuItem
                            primaryText="Dashboard"
                            containerElement={<NavLink to="/admin" />}
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="Promo Codes"
                            containerElement={
                                <NavLink to="/admin/promocodes" />
                            }
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="Gift Credits"
                            containerElement={
                                <NavLink to="/admin/giftcredits" />
                            }
                            style={internals.menuItemStyle}
                        />
                        <MenuItem
                            primaryText="Users"
                            containerElement={<NavLink to="/admin/users" />}
                            style={internals.menuItemStyle}
                        />
                        <Divider />
                        <MenuItem
                            primaryText="Back to App"
                            containerElement={<NavLink to="/" />}
                            style={internals.menuItemStyle}
                        />
                    </IconMenu>
                </div>
                <div className={Classes.navDesktop}>
                    <FlatButton
                        label="Dashboard"
                        containerElement={<NavLink to="/admin" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="Promo Codes"
                        containerElement={<NavLink to="/admin/promocodes" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="Gift Credits"
                        containerElement={<NavLink to="/admin/giftcredits" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <FlatButton
                        label="Users"
                        containerElement={<NavLink to="/admin/users" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                    <Divider />
                    <FlatButton
                        label="Back to App"
                        containerElement={<NavLink to="/" />}
                        labelStyle={internals.buttonLabelStyle}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { isAdmin, isAuthenticated, numCredits } = this.props;

        let nav;

        if (isAdmin && this.props.location.pathname.startsWith("/admin")) {
            nav = this.renderAdminNav();
        } else if (isAuthenticated) {
            nav = this.renderAuthenticatedNav(numCredits);
        } else {
            nav = this.renderNav();
        }

        return (
            <div className={Classes.navBar}>
                <div className={Classes.navBarContainer}>
                    <div className={Classes.logoContainer}>
                        <NavLink to="/" />
                    </div>
                    {nav}
                </div>
            </div>
        );
    }
}

module.exports = withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js